
/**
 * Module dependencies.
 */

import { validate as uuidValidate } from 'uuid';

/**
 * Export `normalizeNewLine`.
 */

export function normalizeNewLine(value: string | null): string | null {
  if (!value) {
    return null;
  }

  const newlineCount = (value.match(/\r\n|\r|\n/g) || []).length;
  const hasBlockTag = /<(p|div|ul|ol|li|table|tr|td|th|h[1-6])\b/i.test(value);

  if (newlineCount >= 3 && !hasBlockTag) {
    const items = value
      .split(/\r\n|\r|\n/)
      .map(line => line.trim())
      .filter(line => line.replace(/<[^>]*>/g, '').trim() !== '');

    if (items.length >= 2) {
      return `<ul>${items.map(item => `<li>${item}</li>`).join('')}</ul>`;
    }
  }

  return value.replace(/(?:\r\n|\r|\n)/g, '<br>');
}

/**
 * Export `isValidUuid`.
 */

export function isValidUuid(uuid: string): boolean {
  return uuidValidate(uuid);
}

/**
 * Export `truncateString`.
 */

export function truncateString(value: string | null, limit?: number): string | null {
  if (!value) {
    return null;
  }

  const limitValue = limit ?? 90;

  if (value.length >= limitValue) {
    const truncated = value.slice(0, limitValue);
    const lastWordIndex = truncated.lastIndexOf(' ');

    return truncated.slice(0, lastWordIndex).concat('...');
  }

  return value;
}

/*
 * Export `normalizeNewLine`.
 */

export function normalizeWebsiteUrl(value: string): string {
  return `www${value.substr(value.indexOf('.'))}`;
}

/**
 * Export `isEmptyHtml`.
 *
 * Rich text fields from the CMS can hold markup with no text (`<p></p>`,
 * `<p><br></p>`, `&nbsp;`) when left empty.
 */

export function isEmptyHtml(value?: string | null): boolean {
  if (!value) {
    return true;
  }

  return value
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim() === '';
}

/**
 * Export `splitHtml`.
 */

export function splitHtml(htmlString: string) {
  return htmlString.match(/<(h2|h3|h4|h5|h6|ol|ul|p|a)[^>]*>.*?<\/\1>/gs);
}
